// extracted by mini-css-extract-plugin
export default {"events-feed-right-side":"EventsFeedRightSide_events-feed-right-side__BX7wX","events-feed-right-side__title":"EventsFeedRightSide_events-feed-right-side__title__RDMso"};